import { ClientDataStorage } from '@rxweb/storage';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class BrowserStorage extends ClientDataStorage {

}
